import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/colors";

export const StyledContentContainer = withViewportStyle("div")`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  gap: ${rem(128)};

  ${(props) => props.$viewport.tablet`
    gap: ${rem(24)};
  `}

  ${(props) => props.$viewport.mobile`
    grid-template-columns: 1fr;
  `}

  .image-primitive {
    min-height: ${rem(576)};
    object-fit: cover;
    max-width: ${rem(496)};
    margin: auto;

    ${(props) => props.$viewport.tablet`
      max-width: 100%;
    `}

    ${(props) => props.$viewport.mobile`
      min-height: unset;
    `}
  }

  .button-primitive {
    background: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
    color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  }
`;

export const PaddingWrapper = withViewportStyle("div")`
  padding: ${rem(80)} ${rem(24)} 0;

  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `}
`;
